import { render } from "./createProposalComponent.vue?vue&type=template&id=3dc58567"
import script from "./createProposalComponent.vue?vue&type=script&lang=js"
export * from "./createProposalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__